module.exports = __webpack_public_path__ + "img/icon_arrow_left_black.5bd94359.svg";